import React from 'react';
import { connect } from 'react-redux';
import { number, shape, string } from 'prop-types';
import SafePureComponent from '../shared/SafePureComponent';
import { getCurrentContent } from '../../utils/ugc/getCurrentContent';
import UserInfo from '../shared/UserInfo';

import './style.scss';

const BusinessOverview = ({ overview, gigTitle }) => (
    <div className="business-overview">
        <h1 className="text-display-3">{gigTitle}</h1>
        <UserInfo overview={overview}/>
    </div>
);

BusinessOverview.propTypes = {
    overview: shape({
        gig: shape({
            title: string.isRequired,
            rating: number,
            ratingsCount: number,
            ordersInQueue: number
        })
    }),
    gigTitle: string
};

const mapStateToProps = ({ ugc }) => {
    const { gigTitle } = getCurrentContent({ ugc });

    return {
        gigTitle
    };
};

const ConnectedBusinessOverview = connect(mapStateToProps)(BusinessOverview);

export { BusinessOverview };
export default SafePureComponent(ConnectedBusinessOverview);
